import React, { useContext } from "react";
import PropTypes from "prop-types";
import DataTable from "../../../../components/DataTable";
import { ALL_VW_VEHICLE_ELD_READING_QUERY } from "../../../../graphql/Vehicles/Vehicles.graphql";
import { ModalContext } from "../../../../components/ModalProvider";
import { VEHICLE_ELD_COLUMNS } from "../columns";
import { EditVehicleELDReadingForm } from "../../../../components/Vehicles";

function ElectronicLogDevice({ filters }) {
  const { setModalOpen } = useContext(ModalContext);

  return (
    <DataTable
      columns={VEHICLE_ELD_COLUMNS}
      dataQuery={ALL_VW_VEHICLE_ELD_READING_QUERY}
      initialSortBy={[{ id: "ELDDate", desc: true }]}
      name="VW_VehicleELDReading"
      where={{ ...filters }}
      onRowClick={VehicleELDReading =>
        setModalOpen(
          true,
          <EditVehicleELDReadingForm
            VehicleELDReading={VehicleELDReading}
            onComplete={() => setModalOpen(false, "")}
          />
        )
      }
    />
  );
}
ElectronicLogDevice.propTypes = {
  filters: PropTypes.object
};
export default ElectronicLogDevice;
